// ─── Query Key Factory ──────────────────────────────────────────────────
// Centralized query key definitions for TanStack Query.
// All query keys are defined here to prevent duplication and ensure
// correct invalidation after mutations.

export const queryKeys = {
	auth: {
		me: ['auth', 'me'] as const,
	},
	incidents: {
		all: ['incidents'] as const,
		list: (params?: { limit?: number; offset?: number }) => ['incidents', 'list', params] as const,
		detail: (id: string) => ['incidents', 'detail', id] as const,
		timeline: (id: string) => ['incidents', 'timeline', id] as const,
		evidence: (id: string, type?: string) => ['incidents', 'evidence', id, type] as const,
	},
	policies: {
		all: ['policies'] as const,
		list: () => ['policies', 'list'] as const,
		exceptions: () => ['policies', 'exceptions'] as const,
	},
	dashboard: {
		all: ['dashboard'] as const,
		overview: () => ['dashboard', 'overview'] as const,
	},
	posture: {
		all: ['posture'] as const,
		summary: () => ['posture', 'summary'] as const,
		repositories: () => ['posture', 'repositories'] as const,
		workflows: (repoId: string) => ['posture', 'workflows', repoId] as const,
		findings: () => ['posture', 'findings'] as const,
		graph: () => ['posture', 'graph'] as const,
		trustGraph: (params: { scope: 'org' | 'repo'; repoId?: string; workflowPath?: string }) =>
			['posture', 'trust-graph', params] as const,
	},
	inventory: {
		all: ['inventory'] as const,
		access: () => ['inventory', 'access'] as const,
		accessDetail: (accessId: string) => ['inventory', 'access', accessId] as const,
		actions: () => ['inventory', 'actions'] as const,
		actionDetail: (actionId: string) => ['inventory', 'actions', actionId] as const,
	},
	org: {
		all: ['org'] as const,
		info: () => ['org', 'info'] as const,
		members: () => ['org', 'members'] as const,
		onboarding: () => ['org', 'onboarding'] as const,
	},
	sync: {
		all: ['sync'] as const,
		state: () => ['sync', 'state'] as const,
	},
	attackPaths: {
		all: ['attack-paths'] as const,
		list: (params?: { minScore?: number; limit?: number }) =>
			['attack-paths', 'list', params] as const,
		forIncident: (incidentId: string) => ['attack-paths', 'incident', incidentId] as const,
	},
	narrative: {
		forIncident: (incidentId: string) => ['narrative', 'incident', incidentId] as const,
	},
	admin: {
		all: ['admin'] as const,
		customers: (params?: { limit?: number; offset?: number }) =>
			['admin', 'customers', params] as const,
		customer: (orgId: string) => ['admin', 'customer', orgId] as const,
		incidents: (params?: { status?: string }) => ['admin', 'incidents', params] as const,
		audit: (params?: { limit?: number; offset?: number }) => ['admin', 'audit', params] as const,
	},
} as const;
